import { render } from "./Market.vue?vue&type=template&id=39fd7d21&scoped=true"
import script from "./Market.vue?vue&type=script&lang=js"
export * from "./Market.vue?vue&type=script&lang=js"

import "./Market.vue?vue&type=style&index=0&id=39fd7d21&scoped=true&lang=css"

import exportComponent from "/builds/Xpansiv/evo/DataPipeline/DataPipeline.Evolve.Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fd7d21"]])

export default __exports__